/* ─────────────────────────────────────────────────────────────
   lala / personalization.js
   Custom message counter + photo upload with drag/drop, previews,
   client-side validation. Submitted as Shopify line item properties.

   File inputs use name="properties[Photo 1]", "properties[Photo 2]"…
   so Shopify attaches the uploaded files directly to the order.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';
  var LA = window.lala = window.lala || {};

  var ACCEPT = ['image/jpeg', 'image/png', 'image/webp', 'image/heic', 'image/heif'];

  function init() {
    document.querySelectorAll('[data-personal]').forEach(initOne);
  }

  function initOne(root) {
    initCounter(root);
    initPhoto(root);
  }

  // ───── message counter ─────
  function initCounter(root) {
    var ta = root.querySelector('[data-personal-message]');
    var counter = root.querySelector('[data-personal-counter]');
    if (!ta || !counter) return;
    var max = parseInt(ta.getAttribute('maxlength') || '0', 10);
    var num = counter.querySelector('b') || counter;
    var update = function () {
      var len = (ta.value || '').length;
      num.textContent = len;
      counter.classList.toggle('is-over', max && len >= max);
    };
    ta.addEventListener('input', update);
    update();
  }

  // ───── photo upload ─────
  function initPhoto(root) {
    var drop = root.querySelector('[data-personal-drop]');
    if (!drop) return;

    var maxFiles = parseInt(drop.dataset.maxFiles || '3', 10);
    var maxMb = parseInt(drop.dataset.maxMb || '12', 10);
    var errFormat = drop.dataset.errFormat || 'Wrong format';
    var errSize = (drop.dataset.errSize || 'Too large — up to {{ mb }} MB').replace('{{ mb }}', maxMb);
    var errCount = (drop.dataset.errCount || 'Up to {{ count }} files').replace('{{ count }}', maxFiles);
    var removeLabel = drop.dataset.removeLabel || 'Remove';
    var previewsHost = root.querySelector('[data-personal-previews]');
    var hiddenHost = root.querySelector('[data-personal-files]'); // ul of file inputs (properties[Photo N])
    var errEl = root.querySelector('[data-personal-error]');
    if (!previewsHost || !hiddenHost) return;

    // Store File objects in a DataTransfer so we can rebuild real inputs per slot
    var slots = []; // [{ file, url }]

    // Ensure N hidden inputs exist (rendered by Liquid too, but we control them here)
    function syncInputs() {
      // Remove existing
      hiddenHost.innerHTML = '';
      slots.forEach(function (s, i) {
        var input = document.createElement('input');
        input.type = 'file';
        input.name = 'properties[Photo ' + (i + 1) + ']';
        input.accept = ACCEPT.join(',');
        input.style.display = 'none';
        // Inject the file via DataTransfer
        try {
          var dt = new DataTransfer();
          dt.items.add(s.file);
          input.files = dt.files;
        } catch (e) {
          // Safari old versions — fallback: leave inputs unwired, submission uses main drop.files
        }
        hiddenHost.appendChild(input);
      });
    }

    function renderPreviews() {
      previewsHost.innerHTML = '';
      slots.forEach(function (s, i) {
        var item = document.createElement('div');
        item.className = 'la-prev';
        item.innerHTML =
          '<img src="' + s.url + '" alt="">' +
          '<button type="button" class="la-prev__rm" data-slot="' + i + '" aria-label="' + removeLabel + '">×</button>' +
          '<span class="la-prev__lbl">' + escapeHtml(truncate(s.file.name, 14)) + '</span>';
        item.querySelector('.la-prev__rm').addEventListener('click', function () {
          slots.splice(i, 1); renderPreviews(); syncInputs();
        });
        previewsHost.appendChild(item);
      });
    }

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg || '';
      errEl.hidden = !msg;
    }

    function addFiles(files) {
      showError('');
      var arr = Array.prototype.slice.call(files || []);
      for (var i = 0; i < arr.length; i++) {
        var f = arr[i];
        if (slots.length >= maxFiles) { showError(errCount); break; }
        if (ACCEPT.indexOf(f.type) === -1 && !/\.(jpe?g|png|webp|heic|heif)$/i.test(f.name)) {
          showError(errFormat); continue;
        }
        if (f.size > maxMb * 1024 * 1024) { showError(errSize); continue; }
        slots.push({ file: f, url: URL.createObjectURL(f) });
      }
      renderPreviews();
      syncInputs();
    }

    // Input change
    var primary = drop.querySelector('input[type=file]');
    if (primary) {
      primary.addEventListener('change', function () { addFiles(primary.files); primary.value = ''; });
    }

    // Drag & drop
    ['dragenter', 'dragover'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); });
    });
    ['dragleave', 'dragend'].forEach(function (ev) {
      drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); });
    });
    drop.addEventListener('drop', function (e) {
      e.preventDefault();
      drop.classList.remove('is-over');
      if (e.dataTransfer && e.dataTransfer.files) addFiles(e.dataTransfer.files);
    });

    // Submission validation — block submit if photos required and none present
    document.addEventListener('lala:product:validate', function (ev) {
      if (!ev.detail || ev.detail.form.contains(root) === false) return;
      if (drop.dataset.required === 'true' && slots.length === 0) {
        showError(drop.dataset.errRequired || 'Please add at least one photo');
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Pink + shake to draw the eye. Force reflow so the animation
        // restarts on a second invalid submit.
        drop.classList.add('is-error');
        drop.classList.remove('la-shake');
        void drop.offsetWidth;
        drop.classList.add('la-shake');
        setTimeout(function () { drop.classList.remove('la-shake'); }, 600);
        ev.preventDefault();
      }
    });

    // Clear the error styling as soon as the user starts dropping/picking files.
    ['dragenter', 'click'].forEach(function (ev) {
      drop.addEventListener(ev, function () { drop.classList.remove('is-error'); });
    });
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; });
  }
  function truncate(s, n) { s = String(s || ''); return s.length > n ? s.slice(0, n - 1) + '…' : s; }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
